<script lang="ts" setup>
import { AuthForgotPasswordForm } from '../../auth/components/index';
definePageMeta({
  layout: 'guest',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
});

useHead({
  title: 'Reset Password',
});
</script>

<template>
  <v-container class="ma-auto d-flex justify-center w-full">
    <AuthForgotPasswordForm />
  </v-container>
</template>

<style lang="scss" scoped>
@use '~/assets/scss/_variables.scss' as *;

.v-card {
  margin-top: 64px;

  @media (max-width: $breakpoint-md) {
    border: none;
    padding: 0;
    margin-top: 0;
  }
}
</style>
